import { useMemo } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (cfg) => {
      const t = await getToken();
      if (t) cfg.headers.Authorization = `Bearer ${t}`;
      return cfg;
    });
    return inst;
  }, [getToken]);
}

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

export async function downloadPdf(api, url, fallbackName) {
  const res = await api.get(url, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const m = cd.match(/filename="([^"]+)"/);
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

export const fmtMoney = (v, dollar = false) => {
  const n = Number(v || 0);
  const s = Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const body = n < -0.004 ? `(${s})` : s;
  return dollar ? `$ ${body}` : body;
};

export const fmtCompact = (v) =>
  Number(v || 0).toLocaleString("en-US", { style: "currency", currency: "USD", notation: "compact", maximumFractionDigits: 2 });

export const fmtPct = (v) => `${Number(v || 0).toFixed(2)}%`;

export const fmtPeriod = (p) => {
  if (!p) return "—";
  const [y, m, d] = p.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const SOURCES = [
  { value: "accounting", label: "Accounting" },
  { value: "brokerage", label: "Brokerage" },
  { value: "investments", label: "Investments" },
  { value: "land", label: "Land & Real Estate" },
  { value: "oilgas", label: "Oil & Gas" },
];

export const SOURCE_LABELS = { ...Object.fromEntries(SOURCES.map((s) => [s.value, s.label])), trialbalance: "Trial Balance", quicken: "Quicken" };

export const KINDS = [
  { value: "entity", label: "Entity" },
  { value: "trust", label: "Trust" },
  { value: "individual", label: "Individual" },
];
